/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForAppSecopsEntityBulkUpdate extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForAppSecopsEntityBulkUpdate");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForAppSecopsEntityBulkUpdate.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForAppSecopsEntityBulkUpdate>): BackgroundJobPayloadForAppSecopsEntityBulkUpdate {
        let obj = Object.assign(new BackgroundJobPayloadForAppSecopsEntityBulkUpdate(), model);
        BackgroundJobPayloadForAppSecopsEntityBulkUpdate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForAppSecopsEntityBulkUpdate>): BackgroundJobPayloadForAppSecopsEntityBulkUpdate {
        if (!model) return null;
        return BackgroundJobPayloadForAppSecopsEntityBulkUpdate.newInstance(<BackgroundJobPayloadForAppSecopsEntityBulkUpdate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForAppSecopsEntityBulkUpdate) {
        if (!obj) return;

        models.BackgroundJobPayloadForAppSecopsEntityBulkUpdate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForAppSecopsEntityBulkUpdate): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForAppSecopsEntityBulkUpdate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.entity_type) {
            models.AppSecopsEntityType.fixupPrototype(this.entity_type);
        }
    }

    /**
     * Entity type for which the bulk update has to be performed
     */
    entity_type: models.AppSecopsEntityType;

}
